import * as React from 'react';

export function IconTriangleDown(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 12 16" fill="currentColor" {...props}>
      <path fillRule="evenodd" d="M0 5l6 6 6-6H0z" />
    </svg>
  );
}
